package ru.chm.gradereport.ui.screens.course.sheet

import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.requiredWidth
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.style.TextOverflow
import androidx.compose.ui.unit.Dp
import androidx.compose.ui.unit.TextUnit
import androidx.compose.ui.unit.dp

@Composable
internal fun TableLabel(
    text: String,
    width: Dp,
    color: Color,
    size: TextUnit,
    weight: FontWeight,
) {
    Text(
        text = text,
        color = color,
        fontSize = size,
        fontWeight = weight,
        maxLines = 2,
        overflow = TextOverflow.Ellipsis,
        modifier = Modifier.requiredWidth(width).padding(horizontal = 6.dp),
    )
}
